/* Form Page to add walkies */
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import styles from "../../styles/PostCreateEditForm.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Alert from "react-bootstrap/Alert"

import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";

const WalkiesCreate = () => {
  useRedirect()
  const host = useHostName()
  const [errors, setErrors] = useState({})

  const [postData, setPostData] = useState({
    walkie_channel_production: "",
    walkie_channel_open: "",
    walkie_channel_transportation: "",
    walkie_channel_art_dept: "",
    walkie_channel_rollover: "",
    walkie_channel_camera: "",
    walkie_channel_electric: "",
    walkie_channel_grip: "",
  })

  const {
    walkie_channel_production,
    walkie_channel_open,
    walkie_channel_transportation,
    walkie_channel_art_dept,
    walkie_channel_rollover,
    walkie_channel_camera,
    walkie_channel_electric,
    walkie_channel_grip,
  } = postData;

  const history = useHistory()

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const payload = {
      walkie_channel_production,
      walkie_channel_open,
      walkie_channel_transportation,
      walkie_channel_art_dept,
      walkie_channel_rollover,
      walkie_channel_camera,
      walkie_channel_electric,
      walkie_channel_grip,
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axiosReq.post("/masters/walkies/", payload, {
          headers: { "Content-Type": "application/json" },
        })
        if (response?.success === false) {
          throw response.error;
        }
        history.push(`/${localStorage.getItem("projectSlug")}/walkies/`)
        toast.success(`Walkies Added`);
      } else {
        const response = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/masters/walkies/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error;
        }
        history.push(`/${localStorage.getItem("projectSlug")}/walkies/`)
        toast.success(`Walkies Added Successfully!`);
      }
    } catch (err) {
      console.log(err)
      const detailMessage =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to add Walkies."
      toast.error(detailMessage)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Create
      </Button>
    </div>
  )

  return (
    <div>
      <TopBox title="Add Walkie Channels" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} text-left my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Container className={`px-0 ${appStyles.Content} ${styles.Container} mb-0 pb-0`} >
        <Form className="mt-0 mb-0 pb-0" onSubmit={handleSubmit}>
          <h5 className={`text-center mt-0 mb-4 py-0 ${styles.SubTitle}`}>
            ADD WALKIE CHANNELS</h5>
          <div className="mt-3 text-center">
            <Row className="pt-2">
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_production" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Production</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_production"
                    value={walkie_channel_production}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_production?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_open" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Open</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_open"
                    value={walkie_channel_open}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_open?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_transportation" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Transport</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_transportation"
                    value={walkie_channel_transportation}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_transportation?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_art_dept" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Art Dept</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_art_dept"
                    value={walkie_channel_art_dept}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_art_dept?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
            </Row>
            <hr className="mb-1" />
            <Row>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_rollover" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Rollover</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_rollover"
                    value={walkie_channel_rollover}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_rollover?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_camera" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Camera</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_camera"
                    value={walkie_channel_camera}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_camera?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_electric" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Electric</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_electric"
                    value={walkie_channel_electric}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_electric?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_grip" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Grip</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_grip"
                    value={walkie_channel_grip}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_grip?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
            </Row>
          </div>
          <Row className="py-3">
            <Col>
              {buttons}
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  )
}

export default WalkiesCreate
